import React from 'react';

import CloudIcon from '../svgicon/CloudMigrationIcon';
import CollocationIcon from '../svgicon/CollocationIcon';
import ServerHostingIcon from '../svgicon/ServerHostingIcon';
import StreamingIcon from '../svgicon/StreamingIcon';

const iconMap = {
  cloud: CloudIcon,
  collocation: CollocationIcon,
  hosting: ServerHostingIcon,
  streaming: StreamingIcon,
};

export default function AnimatedIcon({ type, className = '', active = false }) {
  const IconComponent = iconMap[type];

  if (!IconComponent) {
    console.warn(`Unknown icon type: ${type}`);
    return null;
  }

  // active 상태이면 .active 클래스 추가
  const combinedClassName = `${className} ${active ? 'active' : ''}`;

  return <IconComponent className={combinedClassName} />;
}
